import type { FormattedMsrp } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import { List } from "../../../../list/List"
import { msrpMessages } from "./msrp.messages"

interface FormattedMsrpProps {
	view: FormattedMsrp
}

export const Msrp = ({ view }: FormattedMsrpProps) => {
	const { formatMessage } = useIntl()

	return (
		<List header={view.title}>
			<List.Item label={formatMessage(msrpMessages.totalPrice)} value={view.totalPrice} />
			{view.optionPriceSum && (
				<List.Item label={formatMessage(msrpMessages.optionPriceSum)} value={view.optionPriceSum} />
			)}
		</List>
	)
}
